// custom-search-close.js — Crave search overlay hardening
(function () {
  function getWrapper() {
    return document.querySelector('details-modal.search-modal, details-modal.header__search, details-modal.modal--search');
  }
  function getDetails() {
    // Crave/Dawn-standard: details inside details-modal controls open state
    const wrapper = getWrapper();
    return wrapper ? wrapper.querySelector('details') : null;
  }
  function unlockScroll() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }
  function closeSearch() {
    const details = getDetails();
    const wrapper = getWrapper();
    if (details?.hasAttribute('open')) details.removeAttribute('open');
    wrapper?.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  // Delegate clicks: X button or any element marked to close
  document.addEventListener('click', (e) => {
    const wrapper = getWrapper();
    if (!wrapper) return;

    // Close on the X (Crave/Dawn often uses .modal__close-button)
    if (e.target.closest('[data-search-close], .modal__close-button, .search-modal__close-button')) {
      e.preventDefault();
      closeSearch();
      return;
    }

    // Close when clicking the overlay (the empty backdrop area)
    if (e.target === wrapper) {
      e.preventDefault();
      closeSearch();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const details = getDetails();
      if (details?.hasAttribute('open')) {
        e.preventDefault();
        closeSearch();
      }
    }
  });

  // Safety: if the modal renders open on load but body is scroll-locked, fix it
  document.addEventListener('DOMContentLoaded', () => {
    const details = getDetails();
    const wrapper = getWrapper();
    if (!details) return;
    if (!details.hasAttribute('open')) wrapper?.setAttribute('aria-hidden', 'true');
  });
})();
